import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core'
import { provideAnimations } from '@angular/platform-browser/animations'
import {
  PreloadAllModules,
  provideRouter,
  withComponentInputBinding,
  withPreloading
} from '@angular/router'

import { MARKED_OPTIONS, provideMarkdown } from 'ngx-markdown'

import { provideIconsInitializer } from '@yoshu-lib/core/config/register-icons.factory'
import { provideTranslate } from '@yoshu-lib/core/config/translate.provider'
import { provideKatexMathExtension } from '@yoshu-lib/core/markdown/katex-math.extension'

import { routes } from './app.routes'
import { provideCore } from './core/core.providers'
import { provideAubertduvalHttp } from './core/http/http.provider'

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),

    ...provideCore(),

    provideAubertduvalHttp(),
    provideAnimations(),
    provideRouter(routes, withPreloading(PreloadAllModules), withComponentInputBinding()),
    provideMarkdown(),
    provideKatexMathExtension(),
    { provide: MARKED_OPTIONS, useValue: { gfm: true, breaks: true } },
    provideTranslate(),
    provideIconsInitializer()
  ]
}
